import React from "react";
import { CheckCircle } from "lucide-react";

export default function SuccessModal({ isOpen, onClose, message }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm transition-opacity">
            <div className="bg-gray-800 border border-gray-700 rounded-2xl shadow-2xl p-8 max-w-sm w-full transform transition-all animate-in fade-in zoom-in duration-300">
                <div className="flex flex-col items-center text-center">
                    <div className="bg-green-500/10 p-4 rounded-full mb-4">
                        <CheckCircle className="w-12 h-12 text-green-500" />
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-2">Success!</h3>
                    <p className="text-gray-400 mb-8">{message || "The action was completed successfully."}</p>
                    <button
                        onClick={onClose}
                        className="w-full py-3 px-6 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-all active:scale-95 shadow-lg shadow-blue-600/20"
                    >
                        Great, Thanks!
                    </button>
                </div>
            </div>
        </div>
    );
}
